import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.selectedAccounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
        this.selectedAdAccounts = this.selectedAccounts
            .filter(account => account.accountType === 'AD');
    }

    remove() {
        const accountIds = this.selectedAccounts
            .filter(({isDeletable}) => isDeletable)
            .map(({id}) => id);

        this.isSaving = true;
        this.AccountsResource
            .deleteUserAccounts(this.companyId, accountIds)
            .then(() => {
                this.Alert('success', 'company.user-directories.manage-group.accounts.delete.deleted');
                this.$state.go('^');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/delete/delete-accounts.controller.js